export default __webpack_public_path__ + "static/media/short-beep.b6d71bd0.wav";